/**
 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './react-shims';
import React from 'react';
import ReactDOM from 'react-dom';
import { loadableReady } from '@loadable/component';
import createStore from './redux/create';
import ApiClient from './helpers/ApiClient';
import io from 'socket.io-client';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import history from './history';
import createRoutes from './routesConfig';
import renderRoutes from './routing/renderRoutes';
import RouteDataLoader from './routing/RouteDataLoader';
import { matchRoutes } from 'react-router-config';
import loadBranchData from './routing/loadBranchData';

import { I18nextProvider } from 'react-i18next';
import i18n from './i18n-client.js';

import { actions as idleActions } from 'components/redux-idle-monitor'

const client = new ApiClient();
const dest = document.getElementById('content');
const store = createStore(history, client, window.__data);

import en from '../locales/en/common.json'
import fr from '../locales/fr/common.json'
import de from '../locales/de/common.json'

import Cookies from 'js-cookie'; // Ajouter cette ligne pour utiliser js-cookie



var idleActive = false;

store.subscribe(() => {

  let state = store.getState()

  if (state.auth.user && state.auth.loaded) {
    if (idleActive == false && state.idle.isRunning == false) {
      idleActive = true
      store.dispatch(idleActions.start())
    }

  } else {

    if (idleActive == true && state.idle.isRunning == true) {
      idleActive = false
      store.dispatch(idleActions.stop())//.then(()=>{

      //})
    }


  }

})




// Stocker les subscriptions actives pour re-subscribe après reconnexion
global._wsSubscriptions = {};

function initSocket() {
  const socket = io('', { path: '/ws' });
  socket.on('news', (data) => {

    socket.emit('my other event', { my: 'data from client' });
  });
  socket.on('msg', (data) => {

  });
  
  // Écouter les mises à jour de site_state via WebSocket
  socket.on('site_state_changed', (data) => {
    console.log('[WebSocket] site_state_changed:', data);
    const { siteStateWsUpdate } = require('./redux/modules/products');
    store.dispatch(siteStateWsUpdate(data.siteId, data.state));
  });

  // Re-subscribe aux rooms après reconnexion
  socket.on('reconnect', () => {
    console.log('[WebSocket] Reconnected, re-subscribing to rooms...');
    Object.keys(global._wsSubscriptions).forEach((key) => {
      var sub = global._wsSubscriptions[key];
      socket.emit('subscribe_site', { siteId: sub.siteId, client: sub.client });
      console.log('[WebSocket] Re-subscribed to site:', sub.siteId, sub.client);
    });
  });

  return socket;
}

global.socket = initSocket();

// Fonctions pour s'abonner/désabonner aux updates d'un site
global.subscribeSite = (siteId, client) => {
  if (global.socket && siteId && client) {
    global.socket.emit('subscribe_site', { siteId, client });
    global._wsSubscriptions[siteId + '_' + client] = { siteId, client };
    console.log('[WebSocket] Subscribed to site:', siteId, client);
  }
};

global.unsubscribeSite = (siteId, client) => {
  if (global.socket && siteId && client) {
    global.socket.emit('unsubscribe_site', { siteId, client });
    delete global._wsSubscriptions[siteId + '_' + client];
    console.log('[WebSocket] Unsubscribed from site:', siteId, client);
  }
};

const lang = Cookies.get('lang') || window.__i18n.locale; 

i18n.addResourceBundle('fr', 'common', fr, true);
i18n.addResourceBundle('en', 'common', en, true);
i18n.addResourceBundle('de', 'common', de, true);
i18n.changeLanguage(lang)


i18n.on('languageChanged', (lng) => {});

const routes = createRoutes();

const initialLocation = {
  pathname: window.location.pathname,
  search: window.location.search
};

const initialBranch = matchRoutes(routes, initialLocation.pathname);

const component = (
  <Router history={history}>
    <RouteDataLoader routes={routes} store={store} client={client}>
      {renderRoutes(routes, { store, client })}
    </RouteDataLoader>
  </Router>
);

if (process.env.NODE_ENV !== 'production') {
  window.React = React; // enable debugger

  if (dest && dest.firstChild && dest.firstChild.attributes && !(dest.firstChild.attributes['data-reactroot'] || dest.firstChild.attributes['data-react-checksum'])) {
    console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.');
  }
}

const hasSSRMarkup = !!(
  dest &&
  dest.firstChild &&
  dest.firstChild.attributes &&
  (dest.firstChild.attributes['data-reactroot'] || dest.firstChild.attributes['data-react-checksum'])
);

const canHydrate = hasSSRMarkup && !(__DEVTOOLS__ && !window.devToolsExtension);

const mount = canHydrate ? ReactDOM.hydrate : ReactDOM.render;

const renderApp = () => {
  if (__DEVTOOLS__ && !window.devToolsExtension) {
  const DevToolsModule = require('./containers/DevTools/DevTools');
  const DevTools = DevToolsModule.default || DevToolsModule;
  ReactDOM.render(
    <I18nextProvider i18n={i18n}>
      <Provider store={store} key="provider">
        <div>
          {component}
          <DevTools />
        </div>
      </Provider>
    </I18nextProvider>,
    dest
  );
  } else {

    mount(
      <I18nextProvider i18n={i18n}>
        <Provider store={store} key="provider">
          {component}
        </Provider>
      </I18nextProvider>,
      dest
    );
  }
};

loadBranchData(initialBranch, {
  store,
  location: initialLocation,
  helpers: { client }
}).then(() => new Promise((resolve) => loadableReady(resolve))).then(renderApp).catch(renderApp);
